<template>
  <div>
    <!-- <SmallSide @toggle="toggle($event)" :activeSide="activeSide" /> -->

    <el-aside  v-if="!activeSide">
      <vs-sidebar right open style="border-radius: 0px">
        <!-- <SideHeader @toggle="toggle($event)" :activeSide="activeSide" /> -->
        <button class="back" @click="show = !show">
          <div class="arrowIcon">
            <i class="fas fa-chevron-right"></i>
          </div>
          فواتير
        </button>
        <div class="fatura" v-if="!show">
          <span @click="goTo('/sales')" v-if="accessLinks('add_sales_bill')">
            <vs-sidebar-item :class="isActive('NewSale') ? 'active' : ''">
              فاتوره مبيعات
            </vs-sidebar-item>
          </span>
          <span
            @click="goTo('/purchases')"
            v-if="accessLinks('add_purchase_bill')"
          >
            <vs-sidebar-item :class="isActive('NewPurchase') ? 'active' : ''">
              فاتوره شراء
            </vs-sidebar-item>
          </span>
          <span
            @click="goTo('/sales/return')"
            v-if="accessLinks('add_sales_return_bill')"
          >
            <vs-sidebar-item :class="isActive('ReturnSale') ? 'active' : ''">
              مرتجع مبيعات
            </vs-sidebar-item>
          </span>
          <span
            @click="goTo('/purchases/return')"
            v-if="accessLinks('add_purchase_return_bill')"
          >
            <!-- <vs-sidebar-item
              :class="isActive('ReturnPurchase') ? 'active' : ''"
            >
              مرتجع مشتريات
            </vs-sidebar-item> -->
          </span>
          <span
            @click="goTo('/customers/payment')"
            v-if="accessLinks('collecting_from_customers')"
          >
            <vs-sidebar-item
              :class="isActive('CustomerPayment') ? 'active' : ''"
            >
              تحصيل من العملاء
            </vs-sidebar-item>
          </span>
          <span
            @click="goTo('/suppliers/payment')"
            v-if="accessLinks('payment_to_suppliers')"
          >
            <vs-sidebar-item
              :class="isActive('SupplierPayment') ? 'active' : ''"
            >
              سداد الى الموردين
            </vs-sidebar-item>
          </span>
          <!-- <button @click="printing()">طباعة</button> -->
        </div>
        <div class="content" v-if="show">
          <!-- <MainAside /> -->
        </div> </vs-sidebar
    ></el-aside>
  </div>
</template>

<script>
// import SideHeader from "./SideHeader";
// import MainAside from "./MainAside";
// import SmallSide from "./smallSidebar.vue";

// import { ipcRenderer } from "electron";
export default {
  components: {
    // SideHeader,
    // MainAside,
    // SmallSide,
  },
  data: () => ({
    active: "sales",
    ind: 0,
    show: false,
    activeSidebar: true,
    activeSide: true,
  }),
  created() {
    // alert(this.$route.name);
  },
  watch: {
    activeSide() {
      this.$emit("toggle", this.activeSide);
    },
  },
  methods: {
    printing() {
      // window.ipcRenderer = ipcRenderer;
      // console.log(ipcRenderer);
      // ipcRenderer.send("printing");
    },
    isActive(routerName) {
      if (this.$route.name == routerName) {
        return true;
      } else {
        return false;
      }
    },
    goTo(routerName) {
      this.$router.push({ path: routerName });
    },
    logout() {
      this.$confirm("هل تريد تسجيل الخروج ؟", "تحذير", {
        confirmButtonText: "موافق",
        cancelButtonText: "رفض",
        type: "warning",
        center: true,
      })
        .then(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("menu");
          localStorage.removeItem("permissionNames");
          this.goTo("/login");
          this.$message({
            type: "success",
            message: "تم تسجيل الخروج بنجاح",
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: 'تم إلغاء'
          // });
        });
    },
    toggle(active) {
      this.activeSide = active;
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>
<style lang="sass">
@import "../styles/aside.scss"
</style>
